const UserRoles = {
    User: 'user',
    Master: 'master',
    Admin: 'admin',
    SuperAdmin: 'superAdmin',
    Coach: 'coach',
} as const;

export default UserRoles;
